<i
    class="{{ prefix }} {{ prefix }}-{{ name }} text-{{ color }}"
    [class.icon-fw]="fixedWidth"
    [class.icon__fill]="fill"
    [class.icon__brand]="brand"
    [class.muted]="disabled"
    [ngStyle]="{ 'font-size.rem': getFontSize(size) }"
></i>
@if (notification) {
    <div class="notification"></div>
}
